// Single source of truth for MotoWear social-media handles.
// Update here → every page that imports it gets the new URL.
export const SOCIALS = [
  {
    key: "instagram",
    label: "Instagram",
    handle: "@motowearstudios",
    url: "https://www.instagram.com/motowearstudios/",
    icon: "M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm10.5 1.5a1 1 0 100 2 1 1 0 000-2zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z",
  },
  {
    key: "facebook",
    label: "Facebook",
    handle: "MotoWear Studios Norwich",
    url: "https://www.facebook.com/MotoWearStudiosNorwich",
    icon: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.99 3.657 9.128 8.438 9.879V14.89H7.898V12h2.54V9.797c0-2.506 1.492-3.89 3.776-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.628.771-1.628 1.563V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.128 22 16.99 22 12z",
  },
  {
    key: "tiktok",
    label: "TikTok",
    handle: "@moto_wear_1",
    url: "https://www.tiktok.com/@moto_wear_1",
    icon: "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.27a8.16 8.16 0 0 0 4.77 1.52V6.34a4.85 4.85 0 0 1-1.84-.35z",
  },
  {
    key: "x",
    label: "X",
    handle: "@motowearthreads",
    url: "https://x.com/motowearthreads",
    icon: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  },
];
